
export default {
    props: [
        'date',
        'files',
    ],

    methods: {
        getDownloadLink(file) {
            return `${this.$config.filesUrl}/download?file=${file.id}`
        }
    }

}
